import isString from 'lodash/isString';

export const wait = (ms: number): Promise<null> =>
  new Promise((resolve) => {
    setTimeout(() => resolve(null), ms);
  });

export function numberWithCommas(x: number | string): string {
  let value: number | string = x;

  if (isString(value)) value = parseFloat((value as string).replace(/,/g, ''));

  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export function numberWithThousands(x: number, necessaryLength = 4): string {
  const xToString = x.toString();

  if (xToString.length < 4 || xToString.length < necessaryLength) return numberWithCommas(xToString);

  return `${xToString.slice(0, -3)}k`;
}

export const stringReplaceAll = (str: string, searchValue: string, replaceValue: string): string => {
  return str.split(searchValue).join(replaceValue);
};

export function isTestEnv(): boolean {
  return process.env.NODE_ENV === 'test';
}
